import { lazy } from 'react'
import { path } from './path'
import TabletLayout from '~/layouts/TabletLayout'

const NotFound = lazy(() => import('../views/ErrorPages/NotFound'))
const RescanQR = lazy(() => import('../views/ErrorPages/RescanQR'))
const TokenRedirect = lazy(() => import('~/views/TokenRedirect'))
const Introduction = lazy(() => import('~/views/Introduction'))
const Home = lazy(() => import('~/views/Home'))
const HomeTablet = lazy(() => import('~/views/HomeTablet'))
const Menu = lazy(() => import('~/views/Menu'))
const MenuTablet = lazy(() => import('~/views/MenuTablet'))
const CallStaff = lazy(() => import('../views/CallStaff'))
const CallStaffTablet = lazy(() => import('../views/CallStaffTablet'))
const OrderHistory = lazy(() => import('~/views/OrderHistory'))
const orderHistoryFoodCourt = lazy(() => import('~/views/OrderHistory/OrderHistoryFoodCourt'))
const Payment = lazy(() => import('~/views/Payment'))
const SearchFood = lazy(() => import('../views/SearchDishes'))
const YourCart = lazy(() => import('~/views/YourCart'))
const Ordering = lazy(() => import('~/views/Ordering'))
const OrderingFoodCourt = lazy(() => import('~/views/Ordering/OrderingFoodCourt'))
const ConfirmedPayment = lazy(() => import('~/views/ConfirmedPayment'))
const ConfirmedPaymentTablet = lazy(() => import('~/views/ConfirmedPaymentTablet'))
const ChoosePaymentMethod = lazy(() => import('~/views/Payment/views/ChoosePaymentMethod'))
const PaymentStatusNotify = lazy(() => import('~/views/Payment/views/PaymentStatusNotify'))
const LandingPage = lazy(() => import('~/views/LandingPage'))
const FoodCourtRedirect = lazy(() => import('~/views/TokenRedirect/FoodCourtRedirect'))
const ShortLinkRedirect = lazy(() => import('~/views/TokenRedirect/ShortLinkRedirect'))
const FoodCourt = lazy(() => import('~/views/FoodCourt'))
const OrderPlacedSouvenir = lazy(() => import('~/views/OrderPlacedSouvenir'))
const ReviewOrder = lazy(() => import('~/views/ReviewOrder'))

const publicRoutes = [
  { path: path.landingPage, component: LandingPage, layout: null },
  { path: path.introduction, component: Introduction, layout: null },
  { path: path.home, component: Home },
  { path: path.homeTablet, component: HomeTablet, layout: TabletLayout },
  { path: path.indexMenu, component: Menu },
  { path: path.indexMenuTablet, component: MenuTablet, layout: TabletLayout },
  { path: path.yourCart, component: YourCart },
  { path: path.callStaff, component: CallStaff },
  { path: path.callStaffTablet, component: CallStaffTablet, layout: null },
  { path: path.ordering, component: Ordering },
  { path: path.orderingFoodCourt, component: OrderingFoodCourt }, // Màn hình ordering dành riêng cho Food court
  { path: path.orderHistory, component: OrderHistory },
  { path: path.orderHistoryFoodCourt, component: orderHistoryFoodCourt }, // Màn hình order history dành riêng cho Food court
  { path: path.payment, component: Payment },
  { path: path.confirmedPayment, component: ConfirmedPayment },
  { path: path.confirmedPaymentTablet, component: ConfirmedPaymentTablet, layout: null },
  { path: path.searchFood, component: SearchFood },
  { path: path.tokenRedirect, component: TokenRedirect, layout: null },
  { path: path.restaurantSlug, component: TokenRedirect, layout: null },
  { path: path.rescanQR, component: RescanQR, layout: null },
  { path: path.choosePaymentMethod, component: ChoosePaymentMethod },
  { path: path.statusPaymentNotify, component: PaymentStatusNotify, layout: null },
  { path: path.statusPaymentInAdvanceNotify, component: PaymentStatusNotify },
  { path: path.foodCourtRedirect, component: FoodCourtRedirect, layout: null },
  { path: path.shortLinkRedirect, component: ShortLinkRedirect, layout: null },
  { path: path.foodCourt, component: FoodCourt, layout: null },
  { path: path.orderPlacedSouvenir, component: OrderPlacedSouvenir },
  { path: path.reviewOrder, component: ReviewOrder, layout: null },
  { path: path.notFound, component: NotFound, layout: null }, // Luôn để dòng này ở vị trí cuối cùng
]

export { publicRoutes }
